import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useConsultations } from '../contexts/ConsultationContext';
import ConsultationForm from './ConsultationForm';
import BrandLogoLockup from './BrandLogoLockup';

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isConsultationModalOpen, setIsConsultationModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { addConsultation } = useConsultations();

  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Gallery', href: '/gallery' },
    { name: 'Contact', href: '/contact' },
  ];

  const handleBookConsultation = () => {
    setIsConsultationModalOpen(true);
    setIsMobileMenuOpen(false);
  };

  const handleConsultationSubmit = (consultationData) => {
    addConsultation(consultationData);
  };

  const handleCloseConsultationModal = () => {
    setIsConsultationModalOpen(false);
  };

  const handleVirtualTour = () => {
    navigate('/virtual-tour');
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav className="fixed top-0 left-0 w-full z-50 shadow-[0_4px_30px_rgba(0,0,0,0.03)]" style={{backgroundColor: '#2D2D2D'}}>
        <div className="flex justify-between items-center gap-4 px-4 sm:px-8 md:px-16 py-3 sm:py-4 w-full max-w-screen-2xl mx-auto">
          <Link
            to="/"
            className="relative z-10 flex shrink-0 items-center justify-start self-center"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Jatin Interiors — Home"
          >
            <BrandLogoLockup variant="nav" />
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex gap-4 sm:gap-6 lg:gap-10 items-center font-manrope tracking-tight font-medium">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                className={`${
                  location.pathname === link.href 
                    ? 'font-bold border-b-2 pb-1' 
                    : 'hover:text-primary'
                } hover:scale-105 transition-transform duration-300 ease-out text-sm sm:text-base`}
                style={{
                  color: location.pathname === link.href ? '#FFFFFF' : '#CCCCCC',
                  borderColor: location.pathname === link.href ? '#FFFFFF' : 'transparent'
                }}
                to={link.href}
              >
                {link.name}
              </Link>
            ))}
            {/* 3D Virtual Tour Button */}
            <button
              onClick={handleVirtualTour}
              className="px-4 py-2 rounded-full font-medium hover:scale-105 transition-all duration-400 ease-in-out shadow-sm text-sm sm:text-base border border-primary/30 hover:border-primary/50"
              style={{color: '#C8A96A', borderColor: '#C8A96A'}}
            >
              3D Tour
            </button>
          </div>

          {/* CTA Button - Desktop */}
          <div className="hidden md:block">
            <button 
              onClick={handleBookConsultation}
              className="px-6 sm:px-8 py-2 sm:py-3 rounded-full font-medium hover:scale-105 transition-all duration-400 ease-in-out shadow-sm text-sm sm:text-base" 
              style={{backgroundColor: '#C8A96A', color: '#FFFFFF'}}
            >
              Book Consultation
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span className="material-symbols-outlined text-xl sm:text-2xl" style={{color: '#FFFFFF'}}>
              {isMobileMenuOpen ? 'close' : 'menu'}
            </span>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden backdrop-blur-xl border-t" style={{backgroundColor: '#2D2D2D', borderColor: '#444444'}}>
            <div className="px-4 sm:px-8 py-4 sm:py-6 space-y-3 sm:space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  className={`block py-2 sm:py-3 text-base sm:text-lg ${
                    location.pathname === link.href 
                      ? 'font-bold' 
                      : 'hover:text-primary'
                  }`}
                  style={{
                    color: location.pathname === link.href ? '#FFFFFF' : '#CCCCCC'
                  }}
                  to={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <button 
                onClick={handleVirtualTour}
                className="w-full px-6 py-3 rounded-full font-medium hover:scale-105 transition-all duration-400 text-sm sm:text-base border border-primary/30 hover:border-primary/50"
                style={{color: '#C8A96A', borderColor: '#C8A96A'}}
              >
                3D Virtual Tour
              </button>
              <button 
                onClick={handleBookConsultation}
                className="w-full px-6 py-3 rounded-full font-medium hover:scale-105 transition-all duration-400 mt-4 text-sm sm:text-base" 
                style={{backgroundColor: '#C8A96A', color: '#FFFFFF'}}
              >
                Book Consultation
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Consultation Form Modal */}
      <ConsultationForm
        isOpen={isConsultationModalOpen}
        onClose={handleCloseConsultationModal}
        onSubmit={handleConsultationSubmit}
      />
    </>
  );
};

export default Navigation;
